import { useState } from 'react';
import { milestones } from '@/mocks/data';

const faqs = [
  {
    q: '91黑料吃瓜网的信息来源是否可靠？',
    a: '91黑料吃瓜网的信息来源于多方面的渠道，包括公开报道、网友爆料、内部人士投稿等。我们对每一条信息都会进行初步核实，但由于爆料类内容的特殊性，我们建议读者理性看待所有信息，不盲信、不传谣。我们会在文章中标明信息来源，对于未经证实的内容会明确标注"传闻"或"未经证实"。',
  },
  {
    q: '如何在91黑料吃瓜网上投稿爆料？',
    a: '您可以通过页面底部的"商务合作"表单提交爆料信息，也可以发送邮件至 tips@91heiliaochigua.com。我们承诺对所有爆料人信息严格保密，绝不泄露任何爆料人身份信息。对于重大独家爆料，我们还会提供相应的爆料奖励。',
  },
  {
    q: '文章中的信息不实，如何申请更正或删除？',
    a: '如果您认为某篇文章存在不实信息，请发送邮件至 legal@91heiliaochigua.com，并提供具体的不实之处及相关证据。我们会在收到申请后的24小时内进行审核，确认属实后会立即进行更正或删除处理。',
  },
  {
    q: '91黑料吃瓜网是免费的吗？',
    a: '是的，91黑料吃瓜网对所有用户完全免费。您无需注册或付费即可浏览所有文章和视频内容。我们通过品牌广告和商务合作维持平台运营，不会向用户收取任何费用。',
  },
  {
    q: '如何与91黑料吃瓜网进行商务合作？',
    a: '我们欢迎各类品牌和机构的商务合作。您可以通过页面下方的"商务合作"表单提交合作意向，或发送邮件至 contact@91heiliaochigua.com，我们的商务团队会在3个工作日内与您联系。',
  },
  {
    q: '91黑料吃瓜网的内容更新频率是怎样的？',
    a: '我们保持每日更新，每天至少发布5-10篇新鲜的吃瓜内容。重大突发事件我们会在第一时间进行报道，确保您不错过任何精彩的吃瓜事件。',
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('company_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      form.reset();
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    setFormStatus('submitting');
    setFormError('');

    try {
      const response = await fetch('https://readdy.ai/api/form/d96e5enpg5pqhofcunvg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string } } = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed.code === 'OK') {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 3000);
      } else {
        const serverMsg = parsed?.meta?.message || '提交失败，请稍后重试';
        setFormError(serverMsg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <title>关于我们 - 91黑料吃瓜网 | 品牌介绍与商务合作</title>
      <meta name="description" content="91黑料吃瓜网是国内领先的黑料吃瓜内容集散地，提供最新吃瓜视频与深度黑料直击。了解我们的品牌故事、平台数据与商务合作联系方式。" />
      <meta name="keywords" content="91黑料吃瓜网, 关于我们, 品牌介绍, 商务合作, 吃瓜平台" />
      <link rel="canonical" href="https://91heiliaochigua.com/about" />
      <meta property="og:title" content="关于我们 - 91黑料吃瓜网" />
      <meta property="og:description" content="91黑料吃瓜网是国内领先的黑料吃瓜内容集散地，了解我们的品牌故事与商务合作联系方式。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://91heiliaochigua.com/about" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="关于我们 - 91黑料吃瓜网" />
      <meta name="twitter:description" content="91黑料吃瓜网是国内领先的黑料吃瓜内容集散地，了解我们的品牌故事与商务合作联系方式。" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "关于我们 - 91黑料吃瓜网",
        "url": "https://91heiliaochigua.com/about",
        "description": "91黑料吃瓜网是国内领先的黑料吃瓜内容集散地",
        "isPartOf": {
          "@type": "WebSite",
          "name": "91黑料吃瓜网",
          "url": "https://91heiliaochigua.com"
        }
      }) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map((faq) => ({
          "@type": "Question",
          "name": faq.q,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.a
          }
        }))
      }) }} />

      <section className="w-full px-4 md:px-6 pt-16 pb-14 md:pt-20 md:pb-20 bg-background-50">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-5">
            关于91黑料吃瓜网
          </h1>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            国内领先的黑料吃瓜内容集散地。我们致力于为吃瓜群众提供最新、最快、最全的网红塌房、主播八卦、明星黑料等独家内容。
          </p>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-14 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8">
            {milestones.map((m) => (
              <div key={m.label} className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-primary-500 font-heading mb-2">
                  {m.number}
                </div>
                <div className="text-sm text-foreground-500">{m.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mb-6">品牌故事</h2>
              <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                <p>
                  91黑料吃瓜网成立于2024年，由一群热爱娱乐八卦、追求真相的年轻人创立。我们的使命是为广大网民提供一个可靠、及时、全面的吃瓜内容平台。
                </p>
                <p>
                  从最初的个人博客起步，到如今拥有超过50万日活用户的平台，我们始终坚守"真实、快速、深度"的内容理念。每一篇报道都经过多方核实，确保信息的可靠性。
                </p>
                <p>
                  我们的团队由资深娱乐记者、新媒体编辑、视频制作人和技术工程师组成。我们相信，吃瓜不仅是一种娱乐，更是一种对真相的追求和对社会现象的观察。
                </p>
                <p>
                  未来，91黑料吃瓜网将继续深耕内容领域，拓展视频、音频等多种内容形式，为吃瓜群众带来更丰富的内容体验。
                </p>
              </div>
            </div>
            <div>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mb-6">联系我们</h2>
              <div className="space-y-5">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-map-pin-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">地址</p>
                    <p className="text-sm font-medium text-foreground-800">北京市朝阳区传媒产业园A座1508室</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">电话</p>
                    <p className="text-sm font-medium text-foreground-800">400-888-9191</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">邮箱</p>
                    <p className="text-sm font-medium text-foreground-800">contact@91heiliaochigua.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-time-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-0.5">工作时间</p>
                    <p className="text-sm font-medium text-foreground-800">周一至周五 9:00 - 18:00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
              商务合作
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              欢迎各类品牌和机构与我们合作，我们将为您提供优质的推广方案
            </p>
          </div>

          <div className="max-w-lg mx-auto">
            <form
              data-readdy-form
              id="contact-form"
              onSubmit={handleSubmit}
              className="bg-background-50 rounded-lg p-6 md:p-8"
            >
              <div className="space-y-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    您的姓名 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-white text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    电子邮箱 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-white text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
                <div>
                  <label htmlFor="company" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    公司/品牌名称
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-white text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的公司或品牌名称"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    合作需求 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-md bg-white text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                    placeholder="请描述您的合作需求（最多500字）"
                  />
                  <p className="text-xs text-foreground-400 mt-1">最多500字符</p>
                </div>

                <input
                  type="text"
                  name="company_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />

                <button
                  type="submit"
                  disabled={formStatus === 'submitting'}
                  className="w-full py-2.5 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
                >
                  {formStatus === 'submitting' ? '提交中...' : '提交合作需求'}
                </button>

                {formStatus === 'success' && (
                  <div className="p-3 bg-secondary-50 border border-secondary-200 rounded-md text-sm text-secondary-700 text-center">
                    <i className="ri-check-line mr-1"></i>
                    提交成功！我们会在3个工作日内与您联系。
                  </div>
                )}
                {formStatus === 'error' && (
                  <div className="p-3 bg-primary-50 border border-primary-200 rounded-md text-sm text-primary-700 text-center">
                    <i className="ri-error-warning-line mr-1"></i>
                    {formError}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500">
              关于91黑料吃瓜网的常见问题解答
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <details key={idx} className="group bg-background-100 rounded-lg cursor-pointer">
                <summary className="flex items-center justify-between px-5 py-4 text-sm font-medium text-foreground-800 list-none">
                  <span>{faq.q}</span>
                  <span className="ml-4 flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}